import { defineMessages } from 'react-intl';

export const scope = 'src.components.security';

export default defineMessages({
  verify_account_error: `${scope}.verify_account_error`,
  verify_account_error_help: `${scope}.verify_account_error_help`,
  clock_drift_error: `${scope}.clock_drift_error`,
  access_denied_title: `${scope}.access_denied_title`,
  access_denied_error: `${scope}.access_denied_error`,
  access_denied_email: `${scope}.access_denied_email`,
  access_denied_date_time: `${scope}.access_denied_date_time`,
});
